import { z } from 'zod';
/**
 * La charge d'une équipe, **comptée en base** (D24). Deux entiers, pas deux listes : la grille en
 * affiche une dizaine côte à côte, et rapatrier les demandes pour les compter dans le navigateur
 * serait dix requêtes pour deux nombres.
 *
 * Module à part parce que deux schémas la portent — l'équipe entière (`teamCompositionSchema`) et
 * chacune de ses communes (`teamCoverageSchema`) —, et que le second est lui-même un champ du
 * premier : la déclarer dans l'un ferait importer l'autre en boucle.
 */
export const teamLoadSchema = z.object({
    pending: z.number().int().nonnegative(),
    done: z.number().int().nonnegative(),
});
//# sourceMappingURL=team-load.js.map